import React from 'react';
import styles from './footer.module.scss';
import Copyright from './copyright';
import {DefaultFooter} from './default-variant';
import AISummary from './ai-summary/ai-summary';

const Footer = () => (
  <footer className={styles.footer}>
    <DefaultFooter />
    <AISummary />
    <Copyright />
  </footer>
);

export default Footer;
